import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const selfSettlingSleep: BlogMetaData = {
  title: '抱っこでしか寝ないときは？セルフねんねを急がず進める4ステップ',
  description:
    '抱っこでしか寝ない、寝かしつけの抱っこをやめたいと悩む方へ。セルフねんねの意味、安全な寝床、発達差を踏まえ、抱っこ以外の安心へ急がず移る4ステップをモンテッソーリの観察と環境づくりの視点で解説します。',
  thumbnailUrl: '/img/blog-self-settling-sleep.webp',
  filePath: buildBlogFilePath('self-settling-sleep'),
  category: BLOG_CATEGORY.PARENTING,
};
